'use strict';

module.exports = Object.assign({}, require('./errors'), require('./error-marks'));


//////////////////
// WEBPACK FOOTER
// ../node_modules/cloud-base-errors-definitions/lib/index.js
// module id = 174
// module chunks = 0